<template>
  <section>
    <div class="container">
      <div v-if="fill_info == '' && subpage == 'open'" class="row">
        <div class="col-xs-12">
          <div class="form-title">Felhívás, formai kritériumok</div>
          <PerfectScrollbar :options="{wheelPropagation: false, handlers:['click-rail', 'drag-thumb', 'keyboard', 'wheel', 'touch']}" style="height: 50vh; border: 1px solid #f4f4f4; padding: 20px 20px 0px 20px; margin-bottom: 20px;">
          <div class="article-text medium">
<p>Tisztelt Ösztöndíjasok!</p>
<p>A Széchenyi István Egyetem az Új Nemzeti Kiválóság Program keretein belül 2021/2022-es tanévben ötödik alkalommal, ISSN számmal ellátott magyar nyelvű kiadványt jelentet meg az Ösztöndíjasok kutatási eredményeiről. A Tanulmánykötetben való publikálás az első közlés helye*, az <u>ÚNKP Ösztöndíjasok számára kötelező</u>, azt a szakmai záró beszámolóban fel kell tüntetni. Egyéni kérésre, további felhasználás céljából (más ösztöndíjpályázathoz, stb.) a Tanulmánykötetben való publikálásról a kötet megjelenése utáni fél évig igazolást állítunk ki. Az MTMT adatbázisba való feltöltéshez az egyetemi könyvtárban kérhető segítség.</p>
<p>A következő <strong>formai kritériumok</strong> szerint kérjük leadni az anyagokat:</p>
<ul class="ordered-list with-icon" style="padding-bottom: 20px;">
  <li><i class="fa fa-angle-right"></i>Terjedelem: <strong><u>MAXIMUM 8+1 oldal a forrásjegyzékkel együtt</u></strong></li>
  <li><i class="fa fa-angle-right"></i>20 000 n, azaz leütés szóközökkel, egy <strong><u>B5-ös méretű</u></strong> kiadványban</li>
  <li><i class="fa fa-angle-right"></i><strong><u>11 pt, Times New Roman betűtípus</u></strong></li>
  <li><i class="fa fa-angle-right"></i><strong><u>szimpla sorköz</u></strong></li>
  <li><i class="fa fa-angle-right"></i><strong><u>margó minden oldalon 2,5-ös</u></strong></li>
  <li><i class="fa fa-angle-right"></i>Kérjük, a szövegek csak a címek számozásával, de formázás nélkül legyenek leadva, és a törzsszövegben is csak a legfontosabb formázások legyenek</li>
  <li><i class="fa fa-angle-right"></i>Az esetleges ábrákat, fotókat a szövegbe illesztve, illetve külön is fel lehet majd tölteni a KTR felületre</li>
  <li><i class="fa fa-angle-right"></i>A közvetlen hivatkozások lábjegyzetekben, az oldal alján legyenek feltüntetve</li>
  <li><i class="fa fa-angle-right"></i>A szerző neve (nyomtatott nagybetűvel) után legyen megadva 1-es számú lábjegyzetben, hogy az Egyetemen melyik képzésen/Tanszéken (Doktori Iskola/Kar) tanul, oktat. Ugyanebben a lábjegyzetben mindenképpen kerüljön feltüntetésre a Témavezető neve, beosztása, szervezeti egysége – Kar és Tanszék</li>
</ul>
<p><strong>Hallgatóknál:</strong> SZE képzés, Szak. Témavezető: neve, beosztása, SZE Kar, Tanszék.</p>
<p><strong>Munkatársaknál:</strong> SZE Kar/Doktori Iskola, Tanszék, beosztás. Témavezető, mint hallgatóknál, ahol releváns. A lábjegyzetek számozását innen kell folytatni.</p>
<p>Példa:</p>
<p><em>Szerzői adat a tanulmány elején:</em></p>
<p>MOLNÁR LEVENTE <sup>1</sup></p>
<p><em>Lábjegyzet az oldal alján:</em></p>
<p><sup>1</sup> SZE egységes, osztatlan képzés, Zenetanár-Gitártanár. Témavezető: Dr. Arnóth Balázs, egyetemi docens, SZE Művészeti Kar, Szólóhangszerek és Művészetelmélet Tanszék</p>
<p>A lábjegyzetekre nézve a következők betartása fontos:</p>
<p>A közvetlen hivatkozásokat lábjegyzetekben, az oldal alján kérjük feltüntetni. A lábjegyzetben és a forrásjegyzékben szereplő hivatkozások rendje a következő: </p>
<p>Szerző:&nbsp;<em>Cím</em>, évszám, kiadó, kiadás helye, oldalszám. Kérjük, hogy mindenhol vesszőt (és nem pontot) alkalmazzanak a bibliográfiai adatok között. Első alkalommal a szerző/k nevét kiskapitálissal, teljes egészében ki kell írni, külföldiek esetében a vezetéknév kerül előre, majd vesszővel elválasztva a keresztnév. Ha háromnál több szerző van, csak a szerkesztőt kell megjelölni a (szerk.) jelzéssel. A mű címe és alcíme dőlt betűtípussal szerepeljen. Ha van alcím, akkor azt a rendes címtől ponttal szükséges elválasztani, egyébként csak a bibliográfiai hivatkozás legvégén van pont.</p>
<p>Amennyiben folyóiratból, gyűjteményes kötetből származik a forrás, úgy a mű címe után vessző következik, majd az „in” szócska (ami kisbetűvel, kettőspont nélkül szerepel) és a folyóirat vagy gyűjteményes kötet adatai. Utóbbinak rendszerint van szerkesztője, így azt is fel kell tüntetni.</p>
<p>Folyóirat esetén a szám az alábbi formában legyen megjelölve: évszám/sorszám. „szám”.pl. …, in <i>Magyar Jog</i>, 2006/7. szám, 34. o. Ezekben az esetekben nem a közvetlen forrás, hanem a folyóirat vagy gyűjteményes mű címe szerepel dőlt betűvel. Az oldalszámot kis „o” betű jelöli. Internetes forrás esetén a letöltés helyét és idejét fel kell tüntetni</p>

<p>Példák:</p>
<ul class="ordered-list with-icon" style="padding-bottom: 20px;">
  <li>
    <i class="fa fa-angle-right"></i>
    <sup>1&nbsp;</sup>Csécsy György: <em>Védjegyjog és piacgazdaság</em>, 2001, Novotni kiadó, Miskolc, 36. o.
  </li>
  <li>
    <i class="fa fa-angle-right"></i>
    <sup>2&nbsp;</sup>Szladits Károly&nbsp;- Zakkaria, Fareed&nbsp;- Mezey Barna (szerk.):&nbsp;
  </li>
  <li>
    <i class="fa fa-angle-right"></i>
    <sup>3&nbsp;</sup>Bíró György: Átruházó szerződések, in <em>Polgári Jogi Kodifikáció</em>, 2003/2. szám, 14–30. o.
  </li>
  <li>
    <i class="fa fa-angle-right"></i>
    <sup>4&nbsp;</sup>Eörsi Gyula: A tulajdonátszállás kérdéseiről, in Sárközy Tamás – Vékás Lajos&nbsp;(szerk.): <em>Eörsi Gyula emlékkönyv</em>, 2002, HVG-ORAC Lap-és Könyvkiadó Kft., Budapest, 277–420. o.
  </li>
  <li>
    <i class="fa fa-angle-right"></i>
    <sup>5&nbsp;</sup>Menyhárd Attila: A tulajdonjog tárgyai, előadás a <em>Symposium Iubilaei Facultatis Iaurinensis</em> című konferencián, 2010. szeptember 21., Széchenyi István Egyetem Deák Ferenc Állam-és Jogtudományi Kar.
  </li>
  <li>
    <i class="fa fa-angle-right"></i>
    <sup>6&nbsp;</sup>Csiky Péter: A TRIPS egyezmény szerepe a nemzetközi iparjogvédelmi rendszerben, in <em>Iparjogvédelmi és Szerzői Jogi Szemle</em>, 1998/3. szám, http://www.mszh.hu/kiadv/ipsz/199806/csiki.html, 2010. március 14.
  </li>
</ul>
<p>Egy mű ismételt hivatkozása esetén a Szerző vezetékneve valamint az „i. m.” megjelölés és az oldalszám szerepel. Ha ugyanannak a szerzőnek több műve is szerepel a hivatkozások között, az „i. m.” után zárójelben az érintett mű évszámát is fel kell tüntetni. Egymást követő lábjegyzetekben, ugyanarra a műre történő hivatkozás esetén pedig az „Uo.” és oldalszám jelölést kérjük alkalmazni.</p>
<ul class="ordered-list with-icon" style="padding-bottom: 20px;">
  <li>
    <i class="fa fa-angle-right"></i>
    <sup>7&nbsp;</sup>Eörsi:&nbsp;i. m. 298. o.
  </li>
  <li>
    <i class="fa fa-angle-right"></i>
    <sup>8&nbsp;</sup>Uo. 332. o.
  </li>
</ul>
<p>Fontos, hogy a fenti követelmények teljesüljenek minden beadott anyagok esetében, nagymértékben megkönnyítve így a hatékony munkafolyamatot.</p>
<p>Üdvözlettel:<em> ÚNKP felelősök</em></p>
<p style="font-size: 12px; line-height: 1.3em">* A Tanulmánykötetben megjelent cikk publikálása másik kötetben, szakfolyóiratban csak másod- (harmad-, stb.) közlésként lehetséges, akkor is, ha az új címmel, új bevezetéssel jelenik meg, de a szöveg kevesebb, mint 10%-a lett átírva. Az új cikkben kell elhelyezni egy lábjegyzetet, amely utal a másod közlésre: "Az Innovációs és Technológia Minisztérium ÚNKP-21-… (<i>saját ÚNKP kódszámra átírva</i>) kódszámú Új Nemzeti Kiválóság Programjának támogatásával készült, <i>„eredeti cikk címe”</i> c. tanulmány átdolgozott verziója e cikk. Az eredeti tanulmány megjelenésének helye: Új Nemzeti Kiválóság Program 2021/2022 Tanulmánykötet. Széchenyi István Egyetem, Győr, 2022., ISSN 2630-8134, 168-179. (<i>oldalszámok</i>)". Plagizálás teljes kizárása érdekében érdemes felkeresni a könyvtári kollégákat, és segítséget kérni az ön-ellenőrzés kapcsán a <strong>Turnitin</strong> rendszer segítségével. Ennek módját a következő könyvtári útmutató részletezi. <a target="_blank" href="https://lib.sze.hu/images/Turnitin%20%C3%BAtmutat%C3%B3.pdf" title="">https://lib.sze.hu/images/Turnitin%20%C3%BAtmutat%C3%B3.pdf</a></p>
          </div>
          </PerfectScrollbar>
          <button @click="subpage = 'data'" type="button" class="button">Tovább</button>
        </div>
      </div>
      <div v-if="fill_info == '' && subpage == 'data'" class="row">
        <div class="col-xs-12">
          <div class="form-title">Adatok</div>
        </div>
        <div class="col-sm-6">
          <inputbox id="nev" label="Viselt neve <span style='font-size: 10px; display: block; font-weight: 400'>(A dr-i, egyéb nevére vonatkozó előtagokat, a neve után vesszővel elválasztva tüntesse fel)</span>" name="nev" regexp_filter="[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ. ,]+" v-model="form.nev" :errors="errors"/>
        </div>
        <div class="col-sm-6">
          <inputbox id="email" label="E-mail cím <span style='font-size: 10px; display: block; font-weight: 400'>(Pályázat beadásakor megadott)</span>" name="email" v-model="form.email" :errors="errors"/>
        </div>
        <div class="clearfix"></div>
        <div class="col-sm-6">
          <inputbox id="mobilszam" label="Mobilszám" mask="+99 99 / 999 9999" regexp_filter="[0-9]+" name="mobilszam" v-model="form.mobilszam" :errors="errors"/>
        </div>
        <div class="col-sm-6">
          <inputbox id="palyazati_azonosito" label="Pályázati azonosító <span style='font-size: 10px; display: block; font-weight: 400'>(Az egyedi azonosító számot a pályázat befogadásáról szóló értesítő e-mail-ben kapta meg)</span>" name="palyazati_azonosito" v-model="form.palyazati_azonosito" :errors="errors"/>
        </div>
        <div class="clearfix"></div>
        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="1" @change="(value) => { form.tanulmanykotet_dokumentum = value; }" accepted_files="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" :errors="errors" id="tanulmanykotet_dokumentum" label="ÚNKP tanulmány <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és ÚNKP tanulmány legyen. Pl. Györgyné_Kékesi_Ilona_ÚNKP_tanulmány)</span>" name="tanulmanykotet_dokumentum" :loaded_files="form.tanulmanykotet_dokumentum"/>
        </div>
        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="10" @change="(value) => { form.dokumentumok = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="dokumentumok" label="Ábrák / képek" name="dokumentumok" :loaded_files="form.dokumentumok"/>
        </div>
        <div class="col-xs-12">
          <div v-for="(url, i) in form.dokumentum_urlek" style="display: flex; align-items: center; margin-bottom: 5px;">
            <input type="text" placeholder="Külső Url (pl.: http://webcim.hu/dokumentum.pdf)" class="form-control" v-model="form.dokumentum_urlek[i]"/>
            <a :href="form.dokumentum_urlek[i]" target="_blank" style="margin-left: 5px;" class="button only-icon v2">
              <i class="fa fa-eye"></i>
            </a>
            <button @click="deleteUrl(i)" style="margin-left: 5px;" type="button" class="button only-icon">
              <i class="fa fa-trash-o"></i>
            </button>
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 20px;">
            <input type="text" placeholder="Külső Url (pl.: http://webcim.hu/dokumentum.pdf)" class="form-control" v-model="uj_dokumentum_url">
            <button @click="addDocumentUrl" style="margin-left: 5px;" type="button" class="button only-icon v2">
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>

        <div class="col-xs-12">
          <div style="display: flex; justify-content: space-between; align-items: center">
            <button v-on:click="save(1)" :disabled="saving" type="button" class="button">Mentés</button>
            <button v-on:click="save(2)" :disabled="saving" type="button" class="button">Véglegesít</button>
          </div>
        </div>
      </div>
      <div v-if="fill_info != ''" class="row">
        <div class="col-xs-12">
          <div class="form-title">ÚNKP-21 Tanulmánykötet</div>
          <div v-html="fill_info"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';

export default {
  components: {
    PerfectScrollbar
  },
  data: function() {
    return {
      saving: false,
      errors: [],
      fill_info: '',
      subpage: 'open',
      uj_dokumentum_url: '',
      form: {
        nev: '',
        email: '',
        mobilszam: '',
        palyazati_azonosito: '',
        dokumentumok: [],
        dokumentum_urlek: [],
        tanulmanykotet_dokumentum: []
      }
    }
  },

  computed: {
  },

  watch: {
  },

  mounted: function() {
    var _this = this;

  	Vue.nextTick(function() {
      $('.subpage-head-image').height($(window).innerHeight() * .25);
      $(window).scrollTop(0);
      setHeaderDarkLine();

      $(window).resize(function() {
        setHeaderDarkLine();
      });
    });

    this.$root.ajax('form/unkp_tanulmanykotet_ell/21', {
      success: function(response) {
        if (response.error != false) {
          _this.fill_info = response.error;
          return;
        }

        if (response.form != undefined) {
          _this.form = response.form;
        }
      }
    });
  },

  methods: {
    deleteUrl: function(i) {
      this.form.dokumentum_urlek.splice(i, 1);
    },

    addDocumentUrl: function() {
      if (this.uj_dokumentum_url != '') {
        this.form.dokumentum_urlek.push(this.uj_dokumentum_url);
        this.uj_dokumentum_url = '';
      }
    },

    save: function(veglegesit) {
      var _this = this;

      this.saving = true;
      this.errors = [];

      if (this.uj_dokumentum_url != '') {
        swal('Figyelem!', 'Az ábra/kép url-jét "+" jellel adja hozzá a listához.', 'error');
        this.saving = false;
        return;
      }

      this.$root.ajax('form/unkp_tanulmanykotet_ment/21', {
        method: 'POST',
        data: {
          form: JSON.stringify(this.form),
          veglegesit: veglegesit
        },
        success: function(response) {
          _this.saving = false;

          if (response.errors != undefined && response.errors.length > 0) {
            _this.errors = response.errors;

            Vue.nextTick(function() {
              $('html, body').animate({
                scrollTop: $('#' + _this.errors[0].id).offset().top - 50
              }, 500);
            })

          } else if (response.error) {
            swal('Hiba!', response.error, 'error');

          } else {
            _this.fill_info = veglegesit == 1 ? 'Ön elmentette az űrlap kitöltését. Befogadáshoz Önnek véglegesítenie kell a kitöltését. Az űrlap megtekintéséhez kattintson az alábbi <a href="javascript:void(0)" onclick="location.reload()">linkre.</a>' : 'Köszönjük, Ön sikeresen véglegesítette az űrlap kitöltését.';
          }
        }
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// unkp_tanulmanykotet_21.vue?543cd1a8